"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getItemWithTTL = exports.setItemWithTTL = void 0;
/**
 * Stores a value in localStorage with a time-to-live (TTL).
 * @param key The key under which to store the value.
 * @param value The value to store.
 * @param ttl The time-to-live in milliseconds.
 */
const setItemWithTTL = (key, value, ttl) => {
    const now = new Date();
    const item = {
        value,
        expiry: now.getTime() + ttl,
    };
    localStorage.setItem(key, JSON.stringify(item));
};
exports.setItemWithTTL = setItemWithTTL;
/**
 * Retrieves a value from localStorage, checking if it has expired.
 * @param key The key of the value to retrieve.
 * @returns The stored value or null if it has expired.
 */
const getItemWithTTL = (key) => {
    const itemStr = localStorage.getItem(key);
    if (!itemStr) {
        return null;
    }
    try {
        const item = JSON.parse(itemStr);
        const now = new Date();
        if (now.getTime() > item.expiry) {
            localStorage.removeItem(key);
            return null;
        }
        return item.value;
    }
    catch (error) {
        localStorage.removeItem(key);
        return null;
    }
};
exports.getItemWithTTL = getItemWithTTL;
//# sourceMappingURL=local-storage-helper.js.map